import { api } from '@/global/api'
import { TrackingInfo } from '@/modules/simulator/api/types'

export interface FinishSimulationPayload {
  trackingInfo: TrackingInfo
}

export interface FinishSimulationArgs {
  id: string
  payload: FinishSimulationPayload
}

export const finishSimulation = async ({
  id,
  payload
}: FinishSimulationArgs) => {
  await api.post(`/simulation/${id}/finish`, payload)
}
